import { useEffect } from 'react';
import { Outlet, NavLink, useLocation } from 'react-router-dom';
import { Wallet, Compass, History, User } from 'lucide-react';
import { useDiscoverNotification } from '../hooks/useDiscoverNotification';

const tabs = [
    { to: '/wallet', icon: Wallet, label: 'Cartera' },
    { to: '/explore', icon: Compass, label: 'Descubrir' },
    { to: '/history', icon: History, label: 'Historial' },
    { to: '/profile', icon: User, label: 'Perfil' },
];

export default function Layout() {
    const { hasNewStores, markAsSeen } = useDiscoverNotification();
    const location = useLocation();

    // Clear the badge whenever the user is on the Explore page
    useEffect(() => {
        if (location.pathname === '/explore' && hasNewStores) {
            markAsSeen();
        }
    }, [location.pathname, hasNewStores, markAsSeen]);

    return (
        <div className="mx-auto flex min-h-screen max-w-md flex-col bg-white shadow-xl">
            {/* Main content area */}
            <main className="flex-1 overflow-y-auto pb-20">
                <Outlet />
            </main>

            {/* Bottom Tab Bar */}
            <nav className="fixed bottom-0 left-1/2 w-full max-w-md -translate-x-1/2 border-t border-gray-200 bg-white/95 backdrop-blur-sm">
                <div className="flex items-center justify-around py-2">
                    {tabs.map(({ to, icon: Icon, label }) => (
                        <NavLink
                            key={to}
                            to={to}
                            end={to === '/'}
                            className={({ isActive }) =>
                                `flex flex-col items-center gap-0.5 px-3 py-1 text-xs font-medium transition-colors ${isActive
                                    ? 'text-primary'
                                    : 'text-gray-400 hover:text-gray-600'
                                }`
                            }
                        >
                            {({ isActive }) => (
                                <>
                                    <span className="relative">
                                        <Icon
                                            size={22}
                                            strokeWidth={isActive ? 2.5 : 1.8}
                                        />
                                        <span className={`absolute -right-1 -top-1 h-3 w-3 ${to === '/explore' && hasNewStores ? 'flex' : 'hidden'}`}>
                                            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-red-400 opacity-75" />
                                            <span className="relative inline-flex h-3 w-3 rounded-full border-2 border-white bg-red-500" />
                                        </span>
                                    </span>
                                    <span>{label}</span>
                                </>
                            )}
                        </NavLink>
                    ))}
                </div>
            </nav>
        </div>
    );
}
